import React, { FC } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";
import { BaseTransactionDetailsDto } from "../../../../../api-client";
import { BaseTransactionRow } from "./BaseTransactionRow";
import { useDownload } from "../../../../../hooks/useDownload";

interface CashECTransactionTableProps {
  transactions: BaseTransactionDetailsDto[];
  transactionType: "CASH" | "EC";
  onCancel: (transaction: BaseTransactionDetailsDto) => void;
}

/**
 * Shared table component for CASH and EC transactions
 * Both types use BaseTransactionDetailsDto and share identical column structure
 * Implements SRP by focusing only on rendering the table
 */
export const CashECTransactionTable: FC<CashECTransactionTableProps> = ({
  transactions,
  transactionType,
  onCancel,
}) => {
  const { handleDownloadPdf } = useDownload();

  const headers = [
    "Transaktion-Nr.",
    "Rezept-Nr.",
    "Rezeptdatum",
    "Patient",
    "Motiv",
    "Typ",
    "Erstellt von",
    "Mandant",
    "Erstellt am",
    "Preis (€)",
    "Originalbeleg",
    "Dokumentieren",
    "Aktionen",
  ];

  const sortedTransactions = [...transactions].sort((a, b) => {
    return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
  });

  return (
    <TableContainer component={Paper} className="scrollable" sx={{ maxHeight: "650px" }}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            {headers.map((header, idx) => (
              <TableCell
                key={idx}
                align={
                  header === "Aktionen" || header === "Originalbeleg"
                    ? "center"
                    : header === "Preis (€)"
                      ? "right"
                      : "left"
                }
                sx={{ fontWeight: "bold" }}
                className="table-header-cell-rechnung"
              >
                {header}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedTransactions && sortedTransactions.length > 0 ? (
            sortedTransactions.map((transaction) => (
              <BaseTransactionRow
                key={transaction.transactionNumber}
                transaction={transaction}
                onCancel={onCancel}
                onDownloadPdf={handleDownloadPdf}
              />
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={headers.length}>
                <Typography align="center">
                  Für die ausgewählten Daten wurden keine Transaktionen gefunden.
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
